import React from "react"

class SelectTagItem extends React.Component {
    constructor(props) {
        super(props)

        this.handleMouseDown = this.handleMouseDown.bind(this)
        this.onRemove = this.onRemove.bind(this)
        this.handleTouchEndRemove = this.handleTouchEndRemove.bind(this)
        this.handleTouchMove = this.handleTouchMove.bind(this)
        this.handleTouchStart = this.handleTouchStart.bind(this)
    }

    handleMouseDown(event) {
        if (event.type === "mousedown" && event.button !== 0) return
        if (this.props.onClick) {
            event.stopPropagation()
            this.props.onClick(this.props.value, event)
            return
        }
        if (this.props.value.href) event.stopPropagation()
    }

    onRemove(event) {
        event.preventDefault()
        event.stopPropagation()
        this.props.onRemove(this.props.value)
    }

    handleTouchEndRemove(event) {
        // Check if the view is being dragged, In this case
        // we don't want to fire the click event (because the user only wants to scroll)
        if (this.dragging) return

        // Fire the mouse events
        this.onRemove(event)
    }

    handleTouchMove(event) {
        // Set a flag that the view is being dragged
        this.dragging = true
    }

    handleTouchStart(event) {
        // Set a flag that the view is not being dragged
        this.dragging = false
    }

    renderRemoveIcon() {
        if (this.props.disabled || !this.props.onRemove) return
        return (
            <span
                className="icon icon-delete"
                aria-hidden="true"
                onMouseDown={this.onRemove}
                onTouchEnd={this.handleTouchEndRemove}
                onTouchStart={this.handleTouchStart}
                onTouchMove={this.handleTouchMove}
            />
        )
    }

    renderLabel() {
        return this.props.onClick || this.props.value.href ? (
            <a
                href={this.props.value.href}
                target={this.props.value.target}
                onMouseDown={this.handleMouseDown}
                onTouchEnd={this.handleMouseDown}
            >
                {this.props.children}
            </a>
        ) : (
            <span role="option" aria-selected="true" id={this.props.id}>
                {this.props.children}
            </span>
        )
    }

    render() {
        return (
            <div
                className="tag-item grey select-tag"
                style={this.props.value.style}
                title={this.props.value.title}
            >
                {this.props.children}
                {this.renderRemoveIcon()}
            </div>
        )
    }
}

export default SelectTagItem
